const LanguageCode = "te";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode : "te",
  language_based_api:"https://ws-n.webdunia.com/json/page?lang=" + LanguageCode + "&url=",
  Desktop_language_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=te&menuType=NavigationMenu&menuId=1",
  Desktop_header_based_api: "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=te&menuType=NavigationMenu&menuId=1",
  Desktop_footer_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=te&menuType=FooterMenu&menuId=1",
};
export default Globals;
